<template>
  <div class="w-full relative">
    <header
      class="w-full flex px-4 justify-between fixed z-20 bg-white lg:justify-end h-20 border-b-2"
    >
      <div class="block lg:hidden self-center">
        <button @click="isOpen = !isOpen" class="focus:outline-none">
          <svg class="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path
              v-if="isOpen"
              fill-rule="evenodd"
              d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
            />
            <path
              v-if="!isOpen"
              fill-rule="evenodd"
              d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
            />
          </svg>
        </button>
      </div>

      <div class="flex">
        <button
          type="submit"
          class="border-l-2 px-4 sm:px-6 border-r-2 border-gray-300 focus:outline-none"
        >
          <i class="fas fa-bell text-base sm:text-2xl"></i>
        </button>

        <button
          class="px-4 sm:px-6 border-r-2 border-gray-300 focus:outline-none"
          @click="signOut()"
        >
          <i class="fas fa-sign-out-alt text-base sm:text-2xl"></i>
        </button>

        <button class="px-3 sm:px-12 flex items-center focus:outline-none">
          <i class="fas fa-user-circle text-lg sm:text-3xl text-blue"></i>
          <p class="ml-3 text-base text-gray-600">Profile</p>
          <i class="fas fa-chevron-down text-sm text-gray-600 ml-4 sm:ml-8"></i>
        </button>
      </div>
    </header>

    <transition name="slide">
      <div
        v-if="isOpen === true"
        class="top-nav lg:hidden bg-blue px-3 flex flex-col items-start pt-3 pb-4 text-white mt-20"
      >
        <button
          class="py-5 flex items-center ml-5 text-white hover:text-white focus:text-white focus:outline-none space-x-5"
          v-for="(nav, i) in navigation"
          :key="i"
          @click="onClickNav(nav.to)"
        >
          <!-- <i :class="[`${nav.icon}`, 'text-2xl']"></i> -->
          <img :src="nav.icon" alt=".." width="17px" class="text-2xl mx-5" />
          {{ nav.name }}
        </button>

        <button
          class="py-5 flex items-center ml-5 text-white hover:text-white focus:text-white focus:outline-none space-x-5"
          @click="triggerOverlay"
        >
          <!-- <i :class="[`${nav.icon}`, 'text-2xl']"></i> -->
          <!-- <img :src="nav.icon" alt=".." width="17px" class="text-2xl mx-5" /> -->
          <i
            :class="[
              'fas fa-exclamation-triangle',
              'text-base',
              'text-white',
              'mx-5'
            ]"
          ></i>
          SOS
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["navigation"],

  data() {
    return {
      isOpen: false,
      overLayOpen: null
    };
  },
  methods: {
    onClickNav(route) {
      this.$router.push(route), console.log(route);
      this.isOpen = false;
    },

    triggerOverlay() {
      this.$emit("openOverlay", (this.overLayOpen = true));
    },

    ...mapActions({
      signOutActions: "auth/signOut"
    }),

    signOut() {
      this.signOutActions().then(() => {
        this.$router.push({
          name: "Home"
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.slide-enter-active,
.slide-leave-active {
  transition: height 0.3s;
}
.slide-enter-active {
  height: 26rem;
}
.slide-enter,
.slide-leave-active {
  height: 0;
}
.slide-leave {
  height: 26rem;
}
</style>
